import React, {useContext, useEffect, useRef, useState} from 'react';
import {ReactTabulator} from "react-tabulator";
import {toast} from "react-toastify";
import Balance from "../../Factor/Balance";
import {PrintDataContext, SetPrintDataContext} from "../../../Pages";
import axios from "axios";
import {checkForm} from "../../Form";
import {DateObject} from "react-multi-date-picker";
import {useNavigate} from "react-router-dom";
import AddProductSectionSadan from "./AddProductSectionSadan";
import FactorTableJozNEWSadan from "./FactorTableJozNEWSadan";
import {calculateSumOfTableData, calculateTotalSum} from "../SellFactorFunctionsSadan";
import {formatToPersianAddComma} from "../../../utils/CommaSeparator";
import FactorTableJoz from "./FactorTableJoz";

const SellFactorJOZSadan = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {

  const [sum, setSum] = useState({sum:0 , taxPrice:0});
  useEffect(() => {
    setSum(isNaN(calculateTotalSum(sendData).sum) ? sum : calculateTotalSum(sendData))
  }, [sendData])
   return (
    <>
      <div className="total">
        <h5 className="factor-title">فاکتور فروش جزء</h5>
        <AddProductSectionSadan
          sendData={sendData}
          setSendData={setSendData}
          initialData={initialData}
          componentData={componentData}
          setComponentData={setComponentData}
          storeRoomType={'sell'}
          mode={"sell"}
          isShowStoreRoom={true}

        />
        <div className="separate-factor__newSellComponent"
          // ref={seperateFac}
        >


          {
            // اینجا اگه لازم شد جدول جدید رو بزارم میزارم
            <FactorTableJozNEWSadan
              sendData={sendData} setSendData={setSendData} initialData={initialData}
              componentData={componentData} setComponentData={setComponentData}
            />
          }
          {
            // اینجا اگه باگی پیش اومد   جدول قبلی رو بتونم فوری بزارم
            /*
            <FactorTableJoz
              sendData={sendData} setSendData={setSendData} initialData={initialData}
              componentData={componentData} setComponentData={setComponentData}
            />

             */
          }
          {/*<div> جمع کل : {isNaN(sum) ? 0 : sum}</div>*/}
           <div className={'d-flex '}>
             {sum.taxPrice>0 &&<div className='showTotalSum'> مبلغ مالیات:
              : {formatToPersianAddComma(sum.taxPrice)}</div>}
            <div className='showTotalSum'> جمع کل : {formatToPersianAddComma(sum.sum)}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SellFactorJOZSadan;
